<h5 class="dialog-title text-center fw-bold">Attendere prego</h5>
<div class="mb-4" mat-dialog-content>
  <div class="text-center">
    <p>
      Generazione del file in corso. Questa operazione potrebbe richiedere alcuni minuti.
    </p>
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
